import ReactPopup from "components/popup/ReactPopup";
import { JAVASCRIPT_VOID, LOGIN_URL } from "constant/config";
import { setClickLogapi } from "helpers";
import React, { useCallback } from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";
import DarkMode from "./DarkMode";
import NotificationBarWrapper from "./NotificationBarWrapper";
import { UserArea } from "./UserArea";

export default function LoginArea() {
    const authenticationReducer = useSelector((state) => state.authenticationReducer);
    const { is_login, nickname, note_cnt } = authenticationReducer;

    const handleGoLogin = useCallback(() => {
        window.location = `${LOGIN_URL}/afreeca/login.php?szFrom=full&request_uri=${window.encodeURIComponent(window.location.href)}`;
    }, []);

    const handleSetClickLog = useCallback((type) => {
        if (type) {
            setClickLogapi("gnb_00000002", { button_type: type });
        }
    }, []);

    if (is_login) {
        return (
            <div id="logArea" className="log_area">
                <NotificationBarWrapper />

                <ReactPopup
                    trigger={
                        <a href={JAVASCRIPT_VOID} className="nickname">
                            {note_cnt > 0 && <span className="new">New</span>}
                            {nickname}
                            <em />
                        </a>
                    }
                >
                    <UserArea authenticationReducer={authenticationReducer} />
                </ReactPopup>
            </div>
        );
    } else {
        return (
            <div id="logArea" className="log_area">
                {/* 로그인 전 */}
                <span className="join_area">
                    {(
                        <ReactPopup
                            stopPropagation={true}
                            trigger={
                                <button type="button" className="btn_more" tip="Cài đặt">
                                    설정
                                </button>
                            }
                        >
                            <div
                                className="mode_set_area"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.nativeEvent.stopImmediatePropagation();
                                }}
                            >
                                <DarkMode />
                                <ul>
                                    <li>
                                        <a
                                            href="//point.onlive.vn/quick-view"
                                            target="_blank"
                                            onClick={() => handleSetClickLog("item")}
                                            className="my_item"
                                        >
                                            Vật phẩm
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="//point.onlive.vn"
                                            target="_blank"
                                            onClick={() => handleSetClickLog("balloon")}
                                            className="my_balloon"
                                        >
                                            Bóng sao
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="//hotro.onlive.vn/"
                                            target="_blank"
                                            onClick={() => handleSetClickLog("customer")}
                                            className="my_custom"
                                        >
                                            Trung tâm khách hàng
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </ReactPopup>
                    )}

                    <a href={JAVASCRIPT_VOID} className="login" onClick={handleGoLogin}>
                        <Trans>Đăng nhập</Trans>
                    </a>
                </span>
            </div>
        );
    }
}
